import React, { useMemo } from "react";
import {
  Card,
  CardContent,
  CardImage,
  Container,
  Content,
  Markdown,
  PageSubtitle,
  PageTitle,
  PageTitleContainer,
} from "./styles";
import useCurrentDevice from "utils/useCurrentDevice";
import { Devices } from "../../consts/devices";
import SubscriptionForm from "./SubscriptionForm";
import { EnvironmentTypes, currentEnvironment } from "../../../environment";

const isProdEnv = [
  EnvironmentTypes.STAGING,
  EnvironmentTypes.PRODUCTION,
].includes(currentEnvironment);

const BlogTilesComponent = ({
  allStoryComposition = {},
  blogPostTiles = {},
}) => {
  const currentDevice = useCurrentDevice();

  const { blogTileTitle = "", blogTileSubtitle = "" } =
    blogPostTiles?.props ?? {};

  const blogTiles = useMemo(() => {
    const edges = allStoryComposition?.edges ?? [];

    let formIndex = 0;

    switch (currentDevice) {
      case Devices.MOBILE:
        formIndex = 0;
        break;
      case Devices.TABLET:
        formIndex = 1;
        break;
      case Devices.LAPTOP:
        formIndex = 2;
        break;
      case Devices.DESKTOP:
        formIndex = 3;
        break;
      default:
        break;
    }

    const tileComponents = edges?.reduce(
      (
        acc,
        { node: { searchImage, uri, title, shortDescription, devOnly } }
      ) => {
        if (isProdEnv && devOnly) {
          return acc;
        }

        return [
          ...acc,
          <Card key={`${uri}-${title}`} to={`/${uri}`}>
            <CardContent>
              <CardImage item={searchImage} />
              <Markdown className="blog-title">{title}</Markdown>
              <Markdown>{shortDescription}</Markdown>
            </CardContent>
          </Card>,
        ];
      },
      []
    );

    return [
      ...tileComponents.slice(0, formIndex),
      <SubscriptionForm key={"Blog-Form-Card"} formIndex={formIndex} />,
      ...tileComponents.slice(formIndex),
    ];
  }, [currentDevice, allStoryComposition]);

  return (
    <Container>
      <PageTitleContainer>
        <PageTitle>{blogTileTitle}</PageTitle>
        <PageSubtitle>{blogTileSubtitle}</PageSubtitle>
      </PageTitleContainer>
      <Content>{blogTiles}</Content>
    </Container>
  );
};

export default BlogTilesComponent;
